<ion-app >

  @if (showUatBuildBanner) {
    <p class="uat-build-banner" role="status">
      {{ 'app-component.uat-build-banner' | translate }}
    </p>
  }

  <div class="responsive-app-container" [ngClass]="{'full-width': allowFullScreen}" >
    @if (isReady && appDisabled) {
      <div class="page-container ">
        <div class="layout-page-container">
          <ion-row class="layout-title-spacer">
            <ion-col>
              <div class="layout-title-spacer"></div>
            </ion-col>
          </ion-row>
          <ion-row class="layout-title-spacer">
            <ion-col class="layout-page-logo ">
              <img loading="lazy" src="assets/v2/images/vivascore-v.svg" [alt]="'shared-page.logo.alt' | translate">
            </ion-col>
          </ion-row>
          <ion-row class="layout-title-spacer">
            <ion-col>
              <h1>{{'home-page.update.udpate-required' | translate}}</h1>
              <p>{{'home-page.update.update-message' | translate}}</p>
              <ion-button (click)="updateApp()">{{'home-page.update.update-button' | translate}}</ion-button>
            </ion-col>
          </ion-row>
        </div>
      </div>
    }

    @if ((isReady && updateAvailable) || !isOnline) {
      <div class="update-nudges-overlay">
        @if (isReady && updateAvailable) {
          <div class="update-nudge" (click)="updateApp()">
            <span>{{'home-page.update.update-app-minor' | translate}}</span>
          </div>
        }
        @if (!isOnline) {
          <div class="update-nudge">
            <span>{{'home-page.notification.network-offline' | translate}}</span>
          </div>
        }
      </div>
    }


    <!-- app.component.html -->

    @if (isReady && !appDisabled) {
      <a
        class="sr-only skip-link"
        href="#main-content"
        (click)="skipToMainContent($event)"
      >{{ 'app-component.aria.skip-to-main' | translate }}</a>
    }

    @if (isReady && !appDisabled) {
      <div class="app-shell">
        @if (busyLoading) {
          <div class="layout-busy-spinner">
            <viva-spinner color="var(--viva-icon-color)"></viva-spinner>
          </div>
        }
        @if (isReady && chatRouteAllowed && chatAllowed && !vivaBotHiddenByCustomiseMode) {
          <div class="ai-chat-icon">
            <viva-chat color="white" [messageText]="miniChatText" [showMoreInfoButton]="showMoreInfoButton" (onMoreInfoClick)="gotoFullChat()"
            (onBotClicked)="aiChatClicked()" (onCloseBubble)="closeMiniChat()" [interactive]="true"></viva-chat>
          </div>
        }
        <ng-container *ngComponentOutlet="mainMenuComponent" />
        <ion-router-outlet id="main-content" class="background-blur-target" ></ion-router-outlet>
      </div>
    }
  </div>
</ion-app>